// HeroSection.tsx
import { FC } from "react";
import aboutIllus from "../../../images/about-illus.png";
import { useTranslation } from "react-i18next";

const AboutSection: FC = () => {
  const { t } = useTranslation();

  return (
    <section
      id="about"
      className="flex flex-col lg:flex-row mb-12 md:mb-[120px] pt-10 md:pt-[120px] px-8 md:px-[70px] bg-white text-center"
    >
      <img
        src={aboutIllus}
        alt="about-us"
        className="w-full xs:w-[402px] xl:w-[588px] mr-[64px]"
      />

      <div className="flex flex-col flex-1 items-start mt-[39px]">
        <h3 className="text-[#AF8787] font-[600] text-[12px] leading-[14.52px]">
          {t("whoWeAre").toUpperCase()}
        </h3>
        <h3 className="mt-2 text-[#202223] text-left font-[600] text-[32px] leading-[40px] sm:text-[48px] sm:leading-[58.09px]">
          {t("weTransformLives")}
        </h3>
        <p className="mt-6 font-[400] text-4 text-[#6D7175] leading-[24px] text-left">
          {t("aboutSummary")}
        </p>
      </div>
    </section>
  );
};

export default AboutSection;
